import React, { useContext } from 'react';
import { getContext } from 'common';
import { TreeContext, TreeNodeContext, TreeBranchContext } from './';
import Styled from './styles';

export interface TreeIconProps extends React.ComponentPropsWithRef<'div'> {
  /** If true, retain icon's original color. */
  retainColor?: boolean;
  /** Icon. Consider using `Icon` component. */
  children?: React.ReactNode;
}

/** Component to style an Icon in a Tree. Any other props will be provided to the wrapper element. */
const TreeIcon = React.forwardRef<HTMLElement, TreeIconProps>((props: TreeIconProps, ref) => getContext(({ RTL }) => {
  const {
    retainColor,
    children,
    ...otherProps
  } = props;

  const treeContext = useContext(TreeContext);
  const treeNodeContext = useContext(TreeNodeContext);
  const treeBranchContext = useContext(TreeBranchContext);
  const isDisabled = treeNodeContext.disabled || treeBranchContext.disabled;
  const isSelected = treeNodeContext.selected || treeBranchContext.selected;
  const isNodeErrorMessage = treeNodeContext.error && treeNodeContext.errorMessage !== undefined && (typeof treeNodeContext.errorMessage !== 'string' || treeNodeContext.errorMessage.length > 0);
  const isBranchErrorMessage = treeBranchContext.error && treeBranchContext.errorMessage !== undefined && (typeof treeBranchContext.errorMessage !== 'string' || treeBranchContext.errorMessage.length > 0);
  const isError = isNodeErrorMessage || isBranchErrorMessage;
  return (
    <Styled.TreeIcon
      ref={ref}
      RTL={RTL}
      $theme={treeContext.theme}
      disabled={isDisabled}
      selected={isSelected}
      retainColor={retainColor}
      error={isError}
      {...otherProps}
    >
      {children}
    </Styled.TreeIcon>
  );
}));

TreeIcon.displayName = 'TreeIcon';

TreeIcon.defaultProps = {
  children: undefined,
  retainColor: false,
};


export default TreeIcon;
